import React from 'react'
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'
import { Button } from '@/components/ui/button'
import { AlertCircle, CheckCircle } from 'lucide-react'

interface EmailSendingProgressModalProps {
  open: boolean
  onClose: () => void
  progress: EmailProgress
}

export interface EmailProgress {
  status: 'sending' | 'completed' | 'error'
  currentStep: string
  totalEmails: number
  sentEmails: number
  failedEmails: string[]
  successEmails: string[]
  error?: string
}

const EmailSendingProgressModal = ({ open, onClose, progress }: EmailSendingProgressModalProps) => {
  const isCompleted = progress.status === 'completed' || progress.status === 'error'

  return (
    <Dialog open={open} onOpenChange={() => isCompleted && onClose()}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            {progress.status === 'sending' && (
              <span className="flex items-center gap-2">
                <span className="relative flex h-6 w-6">
                  <span className="animate-spin absolute inline-flex h-full w-full rounded-full border-4 border-blue-400 border-t-transparent"></span>
                </span>
                Email Gönderiliyor
              </span>
            )}
            {progress.status === 'completed' && (
              <span className="flex items-center gap-2 text-green-600">
                <CheckCircle className="h-5 w-5" />
                Başarılı
              </span>
            )}
            {progress.status === 'error' && (
              <span className="flex items-center gap-2 text-red-600">
                <AlertCircle className="h-5 w-5" />
                Hata
              </span>
            )}
          </DialogTitle>
          {progress.status === 'sending' && (
            <DialogDescription className="text-center flex flex-col items-center mt-2">
              <div className="text-sm text-gray-600">{progress.currentStep}</div>
              <div className="text-xs text-gray-400 mt-2">
                {progress.sentEmails + progress.failedEmails.length} / {progress.totalEmails}{' '}
                gönderildi
              </div>
            </DialogDescription>
          )}
          {progress.status === 'completed' && (
            <DialogDescription className="text-center flex flex-col items-center mt-2">
              Tüm mailler gönderildi!
            </DialogDescription>
          )}
          {progress.status === 'error' && (
            <DialogDescription className="text-center flex flex-col items-center mt-2">
              <span>{progress.error || 'Gönderim sırasında bir hata oluştu.'}</span>
            </DialogDescription>
          )}
        </DialogHeader>
        {isCompleted && (
          <div className="flex justify-end mt-4">
            <Button onClick={onClose}>Tamam</Button>
          </div>
        )}
      </DialogContent>
    </Dialog>
  )
}

export default EmailSendingProgressModal
